import Form from 'cerebral-module-forms/Form'

function setSearchOptions({ state }) {
  state.set('users.searchOptions', {
    availableOptions: ['includes', 'startsWith', 'endsWith'],
    availableFilters: ['firstname', 'lastname', 'email', 'companies'],
    option: 'includes',
    filters: ['firstname', 'lastname', 'email', 'companies'],
    isOpen: false,
    criteria: null,
    showSnackbar: false,
    form: Form({
      criteria: {
        value: ''
      }
    })
  })
}

export default setSearchOptions



// WEBPACK FOOTER //
// ./src/modules/app/actions/setSearchOptions.js